import { useI18n } from '@cascade/react/i18n';
import { Image, Text } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './PoweredBy.module.scss';
import type { TPoweredByProps } from './PoweredBy.types.ts';
import { LOGO_SMALL_URL, LOGO_SYMBOL_URL } from '#config/index.ts';

export const PoweredBy = ({ isRail }: TPoweredByProps) => {
  const { translate } = useI18n();

  const title = translate('authentication.logo');

  return (
    <div className={clsx(classes['powered-by'], { [classes.rail]: isRail })}>
      {isRail ? null : (
        <Text
          type='caption'
          color='text-30'
          content={translate('brand.poweredBy')}
        />
      )}
      <Image
        src={isRail ? LOGO_SYMBOL_URL : LOGO_SMALL_URL}
        title={title}
        className={classes.logo}
      />
    </div>
  );
};
